import { types } from "../../types/types";

const initialState =  {
    loading: false,
    proveedorInfo: null,
    rubros: [],
    tipoProveedor: [],
    datosContables: [],
    datosContacto: [],
    documentacion: []
}

export const proveedoresReducer = (state = initialState, action) => {
    switch(action.type){
        case types.proveedorAgregar:
            return{
                ...state,
                loading: true
            }
        case types.proveedorAgregarSuccess:
            return{
                ...state,
                proveedorInfo: action.payload
            };
        case types.proveedorAgregarError:
            return{
                ...state,
                proveedorInfo: null,
                loading: false
            }
        case types.proveedorGuardarInformacion:
            return{
                ...state,
                proveedorInfo: action.payload
            }
        case types.proveedorGuardarDatosContables:
            return{
                ...state,
                datosContables: action.payload
            }
        case types.desSeleccionarProveedorInfo:
            return{
                ...state,
                proveedorInfo: null
            }
        case types.desSeleccionarProveedorDatosContacto:
            return{
                ...state,
                datosContacto: []
            }
        case types.desSeleccionarProveedorDatosContable:
            return{
                ...state,
                datosContables: []
            }
        case types.desSeleccionarProveedorDocumentacion:
            return{
                ...state,
                documentacion: []
            }
        case types.rubrosProveedores:
            return{
                ...state,
                loading: true
            }
        case types.rubrosProveedoresSuccess:
            return{
                ...state,
                rubros: action.payload
            }
        case types.rubrosProveedoresError:
            return{
                ...state,
                rubros: null,
                loading: false
            }
        case types.tipoProveedor:
            return{
                ...state,
                loading: true
            }
        case types.tipoProveedorSuccess:
            return{
                ...state,
                tipoProveedor: action.payload
            }
        case types.tipoProveedorError:
            return{
                ...state,
                tipoProveedor: null,
                loading: false
            }
        case types.traerDatosContables:
            return{
                ...state,
                loading: true
            }
        case types.traerDatosContablesSuccess:
            return{
                ...state,
                datosContables: action.payload,
                loading: false
            }
        case types.traerDatosContablesError:
            return{
                ...state,
                datosContables: [],
                loading: false
            }
        case types.datosContactosTraer:
            return{
                ...state,
                loading: true
            }
        case types.datosContactosTraerSuccess:
            return{
                ...state,
                datosContacto: action.payload,
                loading: false
            }
        case types.datosContactosTraerError:
            return{
                ...state,
                datosContacto: [],
                loading: false
            }
        case types.traerDocumentacionProveedor:
            return{
                ...state,
                loading: true
            }
        case types.traerDocumentacionProveedorSuccess:
            return{
                ...state,
                documentacion: action.payload,
                loading: false
            }
        case types.traerDocumentacionProveedorError:
            return{
                ...state,
                documentacion: [],
                loading: false
            }
        default:
            return state;
    }
}